(function() {
	'use strict';

	try {
		angular
			.module('tradeServe.utils.telephony', [])
			.factory('TelephonyOutboundService', [
				'$http', 'Constants',
				function($http, Constants) {
					return {
						getAddressExtension: getAddressExtension,
						getCustomerExtension: getCustomerExtension,
						getOutboundNumber: getOutboundNumber,
					};

					function getOutboundNumber(params) {
						return $http.get(Constants.apiUrl + 'organization/current/telephony/internal', {
							params: params || {}
						});
					}

					function getCustomerExtension(customerId, id, params) {
						return $http.put(
							Constants.apiUrl + 'customer/' + customerId + '/phonenumber/' + id + '/telephonyext',
							{}, {
								params: params || {}
							}
						);
					}

					function getAddressExtension(id, params) {
						return $http.put(
							Constants.apiUrl + 'address/' + id + '/telephonyext',
							{}, {
								params: params || {}
							}
						);
					}
				}
			]);
	} catch(err) {
		console.log(err);
		return;
	}
})();
